import { Component, Input } from '@angular/core';
import { DashboardService } from '../../shared/services/dashboard.service';
import { switchMap, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from '../../shared/services/config.service';
import { MomentModule } from 'ngx-moment';
import { HlCurrencyPipe } from '../../shared/pipes/hl-currency.pipe';
import { RouterLink } from '@angular/router';
import { NgSwitch, NgSwitchCase, NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

export interface PendingPaymentLineItem {
  id: number;
  customer_id: number;
  customer_name: string;
  type: 'docket' | 'sale' | 'repair';
  title: number;
  items: number;
  date: string;
  balance: number;
}

@Component({
    selector: 'app-pending-payment-list',
    templateUrl: './pending-payment-list.component.html',
    standalone: true,
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgSwitch, NgSwitchCase, RouterLink, NgFor, NgIf, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, AsyncPipe, HlCurrencyPipe, MomentModule]
})
export class PendingPaymentListComponent {
  @Input() set docketType(value) {
    console.log(value);
    if (!value) {
      this.listType.next('all');
      return;
    }
    this.listType.next(value);
  }

  listType = new BehaviorSubject<string>('all');

  listItems$ = this.listType.asObservable().pipe(
    switchMap((type) => {
      return this.dashboardService.getPendingPayments(type);
    }),
    tap(console.log)
  );

  columns = ['customer', 'title', 'items', 'date', 'balance'];
  dateFormat = ConfigService.dates.shortDateTimeFormat;

  constructor(private dashboardService: DashboardService) {}
}
